<script setup lang="ts">
/** 공용 — Verification (For Office Use). 변수 없음, 정적 법정 텍스트. (3개 폼 동일) */
</script>

<template>
  <table class="cdd-tbl" style="margin-top:14px">
    <tbody>
      <tr><td class="cdd-sec" colspan="2">VERIFICATION (For Office Use)</td></tr>
      <tr><th style="width:50%">Individual</th><th>Legal Persons / Legal Arrangement</th></tr>
      <tr>
        <td class="cdd-intro">
          To verify and be satisfied with the identity of the customer or beneficial owner through reliable and independent documentation, electronic data or any other measures that the reporting institution deem necessary, for example:
          <div>•&nbsp; Identity Card issued by Malaysian government</div>
          <div>•&nbsp; Employee Identity Card issued by ministries and statutory bodies</div>
          <div>•&nbsp; Foreign passport or identity card issued by the United Nations</div>
          <div>•&nbsp; Documents issued by Malaysian government</div>
          <div>•&nbsp; Biometric identification</div>
          <div>•&nbsp; Organisation that maintains reliable and independent electronic data to verify customer's identity</div>
        </td>
        <td class="cdd-intro">
          To verify the identity of the customer through the following information/documents, for example:
          <div>•&nbsp; Constitution/Certificate of Incorporation/Partnership</div>
          <div>•&nbsp; Reliable references to verify the identity of customer;</div>
          <div style="margin-top:4px">To verify the identity of directors/shareholders with equity interest of more than twenty five percent/Partners through the following documents, for example,</div>
          <div>•&nbsp; Sections 58 and 78 Forms as prescribed by the Companies Commission of Malaysia or equivalent documents for Labuan companies or foreign incorporations</div>
          <div>•&nbsp; Other equivalent documents for other types of legal person</div>
          <div>•&nbsp; Authorisation for any person to represent the entity</div>
          <div>•&nbsp; Letter of authority or directors' resolution.</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
